export class Zbirni{

    constructor() {}

    RacunIzvoda: string = null;
    Naziv: string = null;
    Mesto: string = null;
    BrNalogaDuguje: string = null;
    BrNalogaPotrazuje: string = null;
    KumulativnoDuguje: number = null;
    KumulativnoPotrazuje: number = null;
    PrethodniSaldo: number = null;
    IznosDuguje: number = null;
    IznosPotrazuje: number = null;
    Saldo: number = null;
    DatumIzvoda: string = null;
    BrojIzvoda: string = null;
    RbrObrada: string = null;
    Fah: string = null;
    TipSloga: string = null;

    Deserialize(input:any){
        this.RacunIzvoda=input.RacunIzvoda._text;
        this.Naziv = input.Naziv._text;
        this.Mesto = input.Mesto._text;
        this.BrNalogaDuguje = input.BrNalogaDuguje._text;
        this.BrNalogaPotrazuje = input.BrNalogaPotrazuje._text;
        this.KumulativnoDuguje = parseFloat(input.KumulativnoDuguje._text.split(',').join('.'));
        this.KumulativnoPotrazuje = parseFloat(input.KumulativnoPotrazuje._text.split(',').join('.'));
        this.PrethodniSaldo = parseFloat(input.PrethodniSaldo._text.split(',').join('.'));
        this.IznosDuguje = parseFloat(input.IznosDuguje._text.split(',').join('.'));
        this.IznosPotrazuje = parseFloat(input.IznosPotrazuje._text.split(',').join('.'));
        this.Saldo = parseFloat(input.Saldo._text.split(',').join('.'));
        this.DatumIzvoda = input.DatumIzvoda._text;
        this.BrojIzvoda = input.BrojIzvoda._text;
        this.RbrObrada = input.RbrObrada._text;
        this.Fah = input.Fah._text;
        this.TipSloga = input.TipSloga._text;
        return this;
    }

}